import React from "react";
import { ISuccessModalProps } from "./SuccessModalProps";
import { Container, SuccessModalHelpers } from "./SuccessModalHelpers";

const SuccessModal: React.FC<ISuccessModalProps> = (props) => {
  return (
    <Container id={props.id}>
      <SuccessModalHelpers {...props} />
    </Container>
  );
};

export default SuccessModal;
